import Splide from '@splidejs/splide';

export default class CoursesSlider {
    constructor() {
        this.coursesSliders = [
            ...document.querySelectorAll('.jsFpCoursesSlider'),
        ];

        this.coursesSliderFelxible = [
            ...document.querySelectorAll('.jsPostPageCoursesSlider'),
        ];

        this.events();
    }

    events() {
        if (this.coursesSliders.length) {
            this.coursesSliders.forEach((coursesSlider) =>
                this.initializeCoursesSlider(coursesSlider),
            );
        }

        if (this.coursesSliderFelxible.length) {
            this.coursesSliderFelxible.forEach((coursesSlider) =>
                this.initializeCoursesSliderFlexible(coursesSlider),
            );
        }
    }

    initializeCoursesSlider(coursesSlider) {
        // eslint-disable-next-line no-unused-vars
        const activeSlider = new Splide(coursesSlider, {
            type: 'slide',
            rewind: false,
            arrows: false,
            pagination: false,
            destroy: true,
            gap: '0.9375rem',
            breakpoints: {
                767: {
                    destroy: false,
                    perPage: 2,
                },
                575: {
                    perPage: 1,
                },
            },
        }).mount();
    }

    initializeCoursesSliderFlexible(coursesSlider) {
        // eslint-disable-next-line no-unused-vars
        const activeSlider = new Splide(coursesSlider, {
            type: 'slide',
            arrows: false,
            pagination: true,
            gap: '0.9375rem',
            mediaQuery: 'min',
            classes: {
                pagination: 'splide__pagination products-block__pagination',
            },
            breakpoints: {
                575: {
                    perPage: 1,
                },
            },
        }).mount();
    }
}
